import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { sortedVisible } from "../lib/format";

export const PreviewContext = createContext(null);

export function usePage(slug) {
  const preview = useContext(PreviewContext);
  const [page, setPage] = useState(null);

  useEffect(() => {
    if (preview) return;
    setPage(null);
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setPage({ sections: [] }));
  }, [slug, preview]);

  const data = preview ? preview.content : page;
  const section = (key) => sortedVisible(data).find((s) => s.key === key)?.data || null;
  return { page: data, loading: !data, section };
}

export function Sections({ page, render }) {
  return sortedVisible(page).map((s) => {
    const C = render[s.key];
    return C ? <C key={s.key} data={s.data} /> : null;
  });
}
